import React from "react"
import { about } from "./about.module.scss"
import { useStaticQuery, graphql } from "gatsby"

const getData = graphql`
  {
    strapiAbout {
      description
    }
  }
`

const About = () => {
  const {
    strapiAbout: { description },
  } = useStaticQuery(getData)
  return (
    <section className={about}>
      <article>
        <h2>Hi, I am Serjan</h2>
        <p>{description}</p>
      </article>
    </section>
  )
}

export default About
